import { Outlet, createFileRoute } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { ApiQueryServiceProvider } from '@/api/ApiQueryServiceProvider'
import { useAuth } from '@/contexts/AuthContext'

export const Route = createFileRoute('/root')({
  component: RootComponent,
  notFoundComponent: () => {
    return (
      <div>
        {/* <p>This is the notFoundComponent configured on root route</p>
        <Link to="/">Start Over</Link> */}
      </div>
    )
  },
})

function RootComponent() {
  const { conExJwt } = useAuth()
  return (
    <ApiQueryServiceProvider token={conExJwt ?? undefined}>
      <Outlet />
      {/* Start rendering router matches */}
      <TanStackRouterDevtools position="bottom-right" />
    </ApiQueryServiceProvider>
  )
}